import {
  toTourEventMetadata,
  type TourTrackingEvent,
  type TrackTourEvent,
} from '@ardoq/product-tours';
import { trackEventV2 } from 'tracking/tracking';
import type { TrackingEvent } from 'tracking/trackPayload';

export const toTrackingEvent = (event: TourTrackingEvent): TrackingEvent => {
  switch (event.type) {
    case 'tour-started':
      return {
        event: 'Product tours0 started tour',
        payload: toTourEventMetadata(event),
      };
    case 'step-viewed':
      return {
        event: 'Product tours0 viewed step',
        payload: toTourEventMetadata(event),
      };
    case 'step-anchor-failed':
      return {
        event: 'Product tours0 failed to anchor step',
        payload: toTourEventMetadata(event),
      };
    case 'tour-completed':
      return {
        event: 'Product tours0 ended tour',
        payload: toTourEventMetadata(event),
      };
    case 'tour-dismissed':
      return {
        event: 'Product tours0 dismissed tour',
        payload: toTourEventMetadata(event),
      };
    case 'tour-feedback-given':
      return {
        event: 'Product tours0 gave tour feedback',
        payload: toTourEventMetadata(event),
      };
  }
};

export const trackTourEvent: TrackTourEvent = event =>
  trackEventV2(toTrackingEvent(event));
